import React, { Component } from 'react';
import { setStartDate, setEndDate, toggleTimelineActive } from '../../../actions/dataAction';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import 'rc-slider/assets/index.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import faClock from '@fortawesome/fontawesome-free-solid/faClock';
import {Box} from '../../StyledComponents';
import VisTimeline from 'react-visjs-timeline'
import './Timeline.css'
import moment from 'moment';


const FixedBox = styled(Box)`
  position: fixed;
  bottom:0px;
  left:20px;
  right:20px;
  z-index: 99999;
  margin-bottom:0px;
  padding-bottom:0px;
  padding-top:0px;
  height:0;
  transition: all 300ms ease-in-out;
  overflow: visible;

  ${props => props.active && css`
    height: 100px;
    transition: all 300ms ease-in-out;
    padding-top:10px;
  `}

  @media print {
    display: none !important;
  }
`;

const ToggleButton = styled.div`
  background:#000;
  position:absolute;
  top:-20px;
  width:30px;
  height:20px;
  left:50%;
  transform: translateX(-50%);
  text-align: center;
  cursor: pointer;
`;

const AngleDown = styled(FontAwesomeIcon)`

`;

const Clock = styled(FontAwesomeIcon)`

`;

class Timeline extends Component {
    constructor(props) {
        super(props);
        this.state = {active: false, };
    }

    toggleActive = () => {
      this.props.toggleTimelineActive(this.props.data.timelineActive ? false:true);
    }

    timeSelection() {
      const start = this.props.data.startDate || moment().subtract(1, 'year');
      const end = this.props.data.endDate || new Date();

      return [{
        start: start,
        end: end,
        content: moment(start).format("YYYY-MM-DD") + " - " + moment(end).format("YYYY-MM-DD"),
        editable: true,
      }]
    }

    sameDay(d1, d2) {
      return d1 && d2 &&
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate();
    }

    timeChange(item, minDate) {
      if (item.id === 'minDate') {
        item.time = minDate;
        return false;
      }

      if (item.time <= minDate) {
        return false;
      }

      if (item.id === 'startDate') {
        this.props.setStartDate(item.time);
        return true;
      }

      if (item.id === 'singleTime' && !this.sameDay(item.time, this.props.data.endDate)) {
        this.props.setEndDate(item.time);
      }
      return true;
    }

    options(minDate) {
      // http://visjs.org/docs/timeline/#Configuration_Options
      const min = moment().subtract(5, 'year');
      const max = moment().add(3, 'year');

      return {
          //start: this.props.data.startDate || moment().subtract(1, 'year'),
          //end: this.props.data.startDate || new Date(),
          width: '100%',
          height: '87px',
          stack: false,
          showMajorLabels: true,
          showCurrentTime: true,
          zoomMin: 860000000,
          zoomMax: 999999999993,
          //start: min,
          min: min,
          max: max,
          //hiddenDates: hiddenDates,
          type: 'range',
          moveable: true,
          //editable: true,
          editable: {
            add: false,
            updateTime: true
          },
          selectable: true,
          //remove: false,
          format: {
            minorLabels: {
              minute: 'h:mma',
              hour: 'ha'
            }
          },
          /*
          onUpdate: function (item, callback) {
            item.content = prompt('Edit items text: ', item.content);
            if (item.content != null) {
              callback(item); // send back adjusted item
            }
            else {
              callback(null); // cancel updating the item
            }
          },
          */

          onMove: function (item, callback) {
            const _this = this;
            // Min 1 day length
            var timeDiff = Math.abs(item.start.getTime() - item.end.getTime());
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            if (diffDays <= 0 || item.end <= item.start || item.end < minDate) {
              callback(null);
              return;
            }

            // Start is not in the future
            if (item.start > new Date()) {
              callback(null);
              return;
            }

            // End is not in the future
            if (item.end > new Date()) {
              item.end = new Date();
              _this.props.setEndDate(new Date());
            } else {
              _this.props.setEndDate(item.end);
            }

            // Start is not before data is available
            if (item.start < minDate) {
              item.start = minDate
              _this.props.setStartDate(item.start);
            } else {
              _this.props.setStartDate(item.start);
            }

            item.content = moment(item.start).format("YYYY-MM-DD") + " - " + moment(item.end).format("YYYY-MM-DD");
            callback(item);
          }
      };
    }

    render() {
      const { data } = this.props;

      //const active = this.state && this.state.active;
      const active = data && data.timelineActive;
      //const minDate = moment().subtract(1, 'year');
      const minDate = data.availableDates ? data.availableDates.start : moment().subtract(2, 'year');

      const customTimes = {
        singleTime: data.endDate || new Date(),
        startDate: data.startDate || minDate,
        minDate: minDate
      };
      return (
          <FixedBox active={active}>
              <ToggleButton onClick={() => this.toggleActive()}>{active ? <AngleDown icon={faAngleDown}/>:<Clock icon={faClock}/>}</ToggleButton>
              <VisTimeline options={this.options(minDate)} items={this.timeSelection()} customTimes={customTimes} timechangeHandler={(item) => this.timeChange(item, minDate)}/>
          </FixedBox>
      );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        data: state.data
    };
}

export default connect(mapStateToProps, { setStartDate, setEndDate, toggleTimelineActive })(Timeline);



// WEBPACK FOOTER //
// ./src/components/dataViews/Timeline/Timeline.js